import { Component, EventEmitter, forwardRef, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { ControlContainer, NgForm, NgModelGroup } from '@angular/forms';
import * as _ from 'lodash';
import { ReuniaoService } from 'src/app/services/reuniao/reuniao.service';
import { ComboResponsavelAcaoReuniao } from '../../../core/combo-responsavel-acao-reuniao';


@Component({
  selector: 'combo-edicao-responsavel-acao-reuniao',
  templateUrl: './combo-edicao-responsavel-acao-reuniao.component.html',
  styleUrls: ['./combo-edicao-responsavel-acao-reuniao.component.css'],
  viewProviders: [{ provide: ControlContainer, useExisting: NgForm },
  { provide: ControlContainer, useExisting: forwardRef(() => NgModelGroup) }],
})
export class ComboEdicaoResponsavelAcaoReuniaoComponent implements OnInit {

  @Input() showDisplayId;
  @Input() obrigatorio;
  @Input() selecionado;
  @Input() desabilitado;
  @Input() label;
  @Input() campoPesquisavel = 'nomeResponsavel';
  @Input() fxFlexOffset = "20px";

  @Output() valorChange = new EventEmitter();

  dados = [];
  data: any = {};
  comboSelecionado: any = {};
  constructor(private reuniaoService: ReuniaoService) {
  }

  ngOnInit(): void {
    this.data = Date.now();

    setTimeout(() => {
      let $_evento;
      
      $_evento = this.reuniaoService.getAllResponsaveisAcoesReuniaoByCombo();  

      $_evento.subscribe((reunioes: ComboResponsavelAcaoReuniao[]) => {
        this.dados = reunioes;
        this.preencherCombo();

        this.dados.forEach(a => {
          a.nomeResponsavel = a.nomeResponsavel;
        } );

        
        this.dados.sort((a, b) => {
          if (a.nomeResponsavel > b.nomeResponsavel) { return 1; }
          return 0;
        });
      });

    }, 0);

  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes["selecionado"] && this.selecionado && this.selecionado.id) {
      this.preencherCombo();
    }
  }

  private preencherCombo() {
    if (this.comboSelecionado && this.comboSelecionado.nomeResponsavel) {
      const existe = this.dados.some(item => 
        item.id === this.comboSelecionado.id && item.nomeResponsavel === this.comboSelecionado.nomeResponsavel
      );
      if (!existe) {
        this.dados.push(this.comboSelecionado);
      }
    }
    if (this.selecionado && this.selecionado.id && this.dados.length) {
      this.selecionado = _.find(this.dados, { id: this.selecionado.id });
    }
  }

  onValorChange(registro: any) {
    this.comboSelecionado = registro;
    this.valorChange.emit(registro);
    this.preencherCombo();
  }
}